// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12FhS","questions":"styles_questions__2nKcr","footer":"styles_footer__32BLG"};